// cryptoUtils.js
import crypto from "crypto";

// Static AES-256 key (32 bytes) + IV (12 bytes)
const AES_KEY = Buffer.from([
  1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,
  17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32
]);
const IV = Buffer.from([1,2,3,4,5,6,7,8,9,10,11,12]);

// Convert Buffer to base64
function buf2b64(buf) {
  return buf.toString("base64");
}

// Convert base64 to Buffer
function b642buf(str) {
  return Buffer.from(str, "base64");
}

/**
 * Encrypt HTML string and return base64
 * @param {string} html
 * @returns {string} encrypted base64
 */
export function encryptHtml(html) {
  const data = Buffer.from(html, "utf8");

  const cipher = crypto.createCipheriv("aes-256-gcm", AES_KEY, IV);
  const enc = cipher.update(data);
  const final = cipher.final();
  const authTag = cipher.getAuthTag();

  const encrypted = Buffer.concat([enc, final, authTag]);
  return buf2b64(encrypted);
}

/**
 * Decrypt base64 encrypted HTML and return original HTML
 * @param {string} encryptedB64
 * @returns {string} decrypted HTML
 */
export function decryptHtml(encryptedB64) {
  const encryptedData = b642buf(encryptedB64);

  const tagLen = 16;
  const authTag = encryptedData.slice(encryptedData.length - tagLen);
  const enc = encryptedData.slice(0, encryptedData.length - tagLen);

  const decipher = crypto.createDecipheriv("aes-256-gcm", AES_KEY, IV);
  decipher.setAuthTag(authTag);

  const decrypted = Buffer.concat([decipher.update(enc), decipher.final()]);
  return decrypted.toString("utf8");
}
